import formats from '../../../api/formats.js'
import FieldObject from './FieldObject.js'
import store from '../../../store'
import dialogs from '../../common/dialogs'
import vCalcForm from './CalcForm'

export default
class CalcField extends FieldObject {
  getCode (model) {
    return model[this.name + '_CODE'] ? model[this.name + '_CODE'] + '' : null
  }
  // setCode (model, newCode, onChange) {
  //   if (!this.equalCode(model, newCode)) {
  //     onChange && onChange(model, this.name, newCode)
  //     if (!newCode) {
  //       this.init(model)
  //     } else {
  //       model[this.name + '_CODE'] = newCode
  //     }
  //   }
  // }
  setValue (model, newCode, newObject, onChange) {
    let nCode = newObject ? formats.hashCode(JSON.stringify(newObject)) : null
    if (!this.equalCode(model, nCode)) {
      onChange && onChange(model, this.name, nCode)
    }
    model[this.name + '_CODE'] = nCode
    model[this.name] = nCode ? JSON.stringify(newObject) : null
    this.cxt.updateItems(model)
  }
  getValue (model) {
    let jsonStr = model[this.name]
    return jsonStr ? JSON.parse(jsonStr) : {}
  }
  getDescription (model) {
    let obj = this.getValue(model)
    if (!obj) {
      return ''
    }
    return `Операций (${formats.blank(obj.loans && obj.loans.length)} + ${formats.blank(obj.pays && obj.pays.length)})`
  }
  getHint (model) {
    let obj = this.getValue(model)
    if (!obj) {
      return ''
    }
    let paysSum = obj.pays ? obj.pays.reduce((s, i) => s + i.amount, 0) : null
    let loansSum = obj.loans ? obj.loans.reduce((s, i) => s + i.amount, 0) : null
    return `Поставки: ${formats.blank(loansSum)} руб. Платежи: ${formats.blank(paysSum)} руб.`
  }
  open (model, onChange) {
    let calc = this.getValue(model)
    Promise.resolve(calc)
    .then((calc) => new Promise((resolve, reject) => {
      if (!calc) {
        this.openCalcForm(calc).then((calc) => {
          resolve(calc)
        })
      } else {
        this.openCalcForm(calc).then((calc) => {
          resolve(calc)
        })
      }
    }))
    .then((calc) => {
      this.setValue(model, calc, calc, onChange)
      // console.log('open', model)
      this.cxt.updateItems(model)
    })
  }
  select (model, onChange) {
    this.open(model, onChange)
  }
  openCalcForm (calc) {
    return new Promise((resolve, reject) => {
      dialogs.register('v-calc-form', vCalcForm)
      const onInput = (data) => {
        // console.log('openCalcForm', data)
        resolve(data)
      }
      let title = 'Сверка платежей'
      let fullscreen = store.getters.getIsMobile
      let comp = { template: `
        <v-calc-form :fullscreen="fullscreen" :value="calc" :title="title" v-on:input="onInput" v-on:close="$emit('close')"></v-calc-form>
      `,
        data () {
          return {
            onInput: onInput,
            fullscreen: fullscreen,
            calc: calc,
            title: title
          }
        }
      }
      dialogs.modal(comp)
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/assist/fields/CalcField.js